<template lang='pug'>
//- 已存在提示區塊
div(:class='$style[`cc-popbox-warning`]')
  .popbox-close(v-if='popBoxStatus.include !== `warnWebSocketError`')
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(v-if='popBoxStatus.include === `warnWebSocketError`' :class='$style[`cc-content-new`]')
    IconWarn(:size='70')
    span.font-medium(:class='$style[`cc-popbox-warning-info`]') {{ textInfo }}
    ul(:class='$style[`cc-content-btn-reason`]')
      li(:class='$style[`cc-content-btn-reason-li`]') * 閒置太久會自動關閉，請重新連線。
      li(:class='$style[`cc-content-btn-reason-li`]') * 確保網路連線穩定、信號強度良好。
      //- li(:class='$style[`cc-content-btn-reason-li`]') * 更新瀏覽器至最新版本，或聯繫客服。
    div(:class='$style[`cc-content-btn-area`]')
      button(
        title='重新連線'
        tabindex='0'
        aria-label='重新連線'
        :class='$style[`cc-content-btn`]'
        @click='handleClickToRefresh')
        span 重新連線

  //- DrCell 發生錯誤
  div(v-else-if='popBoxStatus.include === `warnDrcellError`' :class='$style[`cc-content-new`]')
    IconWarn(:size='70')
    span.font-medium(:class='$style[`cc-popbox-warning-info`]') {{ textInfo }}
    div(:class='$style[`cc-content-btn-area`]')
      button(
        title='重新連線'
        tabindex='0'
        aria-label='重新連線'
        :class='$style[`cc-content-btn`]'
        @click='handleClickToRefresh')
        span 重新連線

  //- 其他情況
  div(v-else :class='$style[`cc-content-new`]')
    IconWarn(:size='70')
    span.font-medium(:class='$style[`cc-popbox-warning-info`]') {{ textInfo }}
    div(:class='$style[`cc-content-btn-area`]')
      button(
        title='知道了'
        tabindex='0'
        aria-label='知道了'
        :class='$style[`cc-content-btn`]'
        @click='handleClosePopBox')
        span 知道了

</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import IconWarn from '../../icon/Warn';

export default {
  components: {
    IconWarn,
  },

  props: {
    textInfo: {
      type: String,
      default: '警告',
    },
  },

  // data() {
  //   return {
  //   };
  // },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    handleClosePopBox() {
      this.changePopBoxStatus({
        active: false,
        include: '',
      });
    },

    handleClickToRefresh() {
      this.$router.go(this.$router.currentRoute);
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      popBoxStatus: 'global/exportPopBoxStatus',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popWarning.scss';
</style>
